import axios from 'axios'
import Vuei18n from "vue-i18n";
import Vue from 'vue'
import store from '../store'
import { Toast } from 'vant'

export function i18nInit() {
    Vue.use(Vuei18n);
    const i18n = new Vuei18n({ locale: 'en-US', });
    window.i18n = i18n
    //从utils库内获取多语言文件，并配置
    let messages = {
        'zh-CN': '/json/zh_CN.json',
        'en-US': '/json/en_US.json',
        'zh-TW': '/json/zh_HK.json',
        'zh-HK': '/json/zh_HK.json',
        'ko-KR': '/json/ko_KR.json',
        'id-ID': '/json/id_ID.json',
        'ja-JP': '/json/ja_JP.json',
        'vi-VN': '/json/vi_VN.json',
        'th-TH': '/json/th_TH.json',
        'ru-RU': '/json/ru_RU.json',
    }
    let promiseArr = []
    Object.keys(messages).map(lang => {
        // console.log(process.env.NODE_ENV);
        
        // 创建带超时的请求
        const timeoutPromise = new Promise((resolve) => {
            // 仅在移动端二维码环境下添加超时
            // if (process.env && process.env.NODE_ENV && process.env.NODE_ENV == 'mobile-qrcode') {
            //     setTimeout(() => {
            //         resolve({ config: { data: JSON.stringify({ lang }) }, data: {} });
            //     }, 500000);
            // }
        });

        const requestPromise = axios({
            url: CONFIG.utilsUrl + messages[lang],
            data: { lang },

        }).catch(err => {
            console.warn(`Failed to load language ${lang}:`, err.message);
            return { config: { data: JSON.stringify({ lang }) }, data: {} };
        });

        // 使用Promise.race确保请求不会无限等待
        promiseArr.push(Promise.race([requestPromise]));
    })
    const p = Promise.all(promiseArr)
    p.then(res => {
        res.forEach(i => {
            try {
                const lang = JSON.parse(i.config.data).lang;
                if (i.data && Object.keys(i.data).length > 0) {
                    window.i18n.setLocaleMessage(lang, i.data);
                }
            } catch (err) {
                console.warn('Error processing language data:', err);
            }
        })
        store.commit('INIT', {
            showPage: true
        })
    }).catch(err => {
        console.error('Error loading language files:', err);
        // 即使加载失败，也显示页面
        store.commit('INIT', {
            showPage: true
        });

        // 显示网络错误提示
        Toast({
            message: 'Network error, using default language',
            type: 'warning',
            duration: 3000
        });
    })
    return i18n
}